import React from 'react'
import { CartPreviewData } from 'types/progressiveDiscountTypes'
import { useProductProgressiveTiers } from 'hooks/useProductProgressiveTiers'
import { CartProgressiveGroupCard } from '../CartProgressiveGroupCard'

type Application = CartPreviewData['applications'][number]

interface GroupApplicationProps {
  application: Application
}

const GroupApplication = ({ application }: GroupApplicationProps) => {
  const firstProductId = application.eligible_items[0]?.product_id
  const { tiers, rule, unitPrice, hasDiscount, loading } = useProductProgressiveTiers(firstProductId)

  if (loading || !hasDiscount || tiers.length === 0) return null

  // Agrupa item, both e shipping puro — qualquer benefit_target agregado forma card de grupo.
  if (rule?.count_mode !== 'aggregated' || !['item', 'both', 'shipping'].includes(rule?.benefit_target ?? ''))
    return null

  if (application.eligible_items.length === 0) return null
  if (!application.tier) return null

  const groupQty = application.eligible_items.reduce((sum, i) => sum + i.quantity, 0)

  return (
    <CartProgressiveGroupCard
      ruleName={application.rule_name}
      groupQty={groupQty}
      activeTier={application.tier}
      rule={rule}
      unitPrice={unitPrice}
      tiers={tiers}
      savings={application.discount}
    />
  )
}

interface SectionProps {
  preview: CartPreviewData | null
}

export const CartProgressiveGroupSection = ({ preview }: SectionProps) => {
  if (!preview || preview.applications.length === 0) return null

  return (
    <>
      {preview.applications.map(app => (
        <GroupApplication key={app.rule_id} application={app} />
      ))}
    </>
  )
}
